var _path, _path2, _line, _line2, _line3, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.344,
    height: 100,
    viewBox: "0 0 74.344 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.129,100H15.215A15.215,15.215,0,0,1,0,84.785V15.215A15.215,15.215,0,0,1,15.215,0H53.358L74.344,21.081v63.7A15.215,15.215,0,0,1,59.129,100Z",
    fill: "#5380c0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.85,20.1H55A4.09,4.09,0,0,1,50.88,16V0",
    transform: "translate(3.494)",
    fill: "#fff",
    opacity: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x2: 49.824,
    transform: "translate(12.26 39.003)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x2: 49.824,
    transform: "translate(12.26 50.315)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x2: 49.824,
    transform: "translate(12.26 61.626)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x2: 23.17,
    transform: "translate(13.158 72.938)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFile);
export default __webpack_public_path__ + "static/media/text-file.1107b880aecf36631c9f80a55fdc8a12.svg";
export { ForwardRef as ReactComponent };